import customAxios from "../../customHook/customAxios";
import { getAuthHeader } from "../../utils";

export const v3_add_schedule_event = async (model) => {
    const url = `/v3/schedule/event`; // No need for full base URL, it's handled
    const response = await customAxios.post(url, model);
    return response.data;
};

export const v3_search_schedule = async (page, limit, payload, pastEventFilter, pastEventPage, pastEventLimit) => {
    const url = `/v3/schedule/${page}/${limit}?payload=${payload}&pastEventPeriods=${pastEventFilter}&pastEventPage=${pastEventPage}&pastEventLimit=${pastEventLimit}`; // No need for full base URL, it's handled
    const response = await customAxios.get(url, getAuthHeader());
    return response.data;
};

export const v3_update_schedule_event = async (model) => {
    const url = `/v3/schedule/update`; // No need for full base URL, it's handled
    const response = await customAxios.post(url, model);
    return response.data;
};

export const v3_delete_schedule_event = async (scheduleId) => {
    const url = `/v3/schedule/${scheduleId}`;
    const response = await customAxios.delete(url, getAuthHeader());
    return response.data;
};

